import styles from './styles.module.scss'
import classNames from 'classnames'
import { ITypographyVariant, Typography } from 'shared/ui/Typography'
import { Icon } from 'shared/ui/Icon'
import { FC, ReactNode } from 'react'

type IEmptyStateProps = {
  title: string
  description: string
  IconFC: FC
  actions?: ReactNode
  variant?: 'primary' | 'secondary'
}

export const EmptyState = ({
  title,
  description,
  IconFC,
  actions,
  variant = 'primary',
}: IEmptyStateProps) => {
  const getTitleVariant = (): ITypographyVariant => {
    if (variant === 'secondary') {
      return 'p0-semiBold'
    }
    return 'h3-semiBold'
  }

  return (
    <div className={classNames(styles.wrap, styles[`variant__${variant}`])}>
      <Icon fontSize={32} className={styles.icon}>
        <IconFC />
      </Icon>
      <Typography variant={getTitleVariant()} className={styles.title}>
        {title}
      </Typography>
      <Typography variant={'p2-regular'} className={styles.desc}>
        {description}
      </Typography>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}
